import { render, staticRenderFns } from "./ReadingList.vue?vue&type=template&id=5684fc6e&scoped=true"
import script from "./ReadingList.vue?vue&type=script&lang=js"
export * from "./ReadingList.vue?vue&type=script&lang=js"
import style0 from "./ReadingList.vue?vue&type=style&index=0&id=5684fc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684fc6e",
  null
  
)

export default component.exports